<template>
  <div
    class="min-h-full max-h-full flex p-1 rounded-md w-full gap-2"
    :style="{
      backgroundColor: 'var(--fundoForm)',
    }"
  >
    <div class="w-[30%] text-[var(--text)] grid grid-cols-2 gap-1 max-h-[100%]">
      <div
        v-for="(tipo, index) in tipos"
        :key="index"
        @click="selectTipo(tipo.nome)"
        v-show="validPermission(tipo.codigo)"
        :class="[
          'flex justify-center items-center px-3 py-2 h-6 cursor-pointer text-[var(--text)] text-xs rounded-md hover:bg-[var(--scroll)]',
          {
            'bg-[var(--fundoComponente)]': selectedTipo !== tipo.nome,
            'bg-[var(--scroll)]': selectedTipo === tipo.nome,
          },
        ]"
      >
        <div class="text-nowrap text-center">{{ tipo.nome }}</div>
      </div>
    </div>
    <div class="w-[70%] overflow-y-auto">
      <AppTipo v-if="selectedTipo" :tipo="selectedTipo" />
    </div>
  </div>
</template>

<script>
import AppTipo from "@/components/tipo/tipo.vue";
import permissionMixin from "@/permissionMixin.js";
export default {
  mixins: [permissionMixin],
  name: "AppTipoTabela",
  components: {
    AppTipo,
  },
  props: {
    tipos: Array,
    default: [],
  },
  data() {
    return {
      tiposVerified: [],
      selectedTipo: null,
    };
  },
  methods: {
    selectTipo(tipo) {
      this.selectedTipo = tipo;
    },
  },
};
</script>
